var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0433 64.9567C11.7659 61.6793 9.16617 57.7885 7.39247 53.5065C5.61878 49.2244 4.70587 44.6349 4.70587 40C4.70587 35.3651 5.61878 30.7756 7.39248 26.4935C9.16617 22.2114 11.7659 18.3206 15.0433 15.0433C18.3206 11.7659 22.2114 9.16618 26.4935 7.39249C30.7756 5.61879 35.3651 4.70588 40 4.70588C44.6349 4.70588 49.2244 5.61879 53.5065 7.39249C57.7885 9.16619 61.6793 11.7659 64.9567 15.0433L15.0433 64.9567Z",
    fill: "#7BE89A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.17645 40C1.17645 18.5888 18.5888 1.17647 40 1.17647C61.4112 1.17647 78.8235 18.5888 78.8235 40C78.8235 61.4112 61.4112 78.8235 40 78.8235C18.5888 78.8235 1.17645 61.4112 1.17645 40ZM40 8.23529C22.4873 8.23529 8.23528 22.4873 8.23528 40C8.23528 57.5127 22.4873 71.7647 40 71.7647C57.5127 71.7647 71.7647 57.5127 71.7647 40C71.7647 22.4873 57.5127 8.23529 40 8.23529Z",
    fill: "#5CD17E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.255 28.0926C58.6333 29.4709 58.6333 31.7056 57.255 33.0839L38.0036 52.3352C36.6253 53.7136 34.3906 53.7136 33.0123 52.3352L23.3867 42.7097C22.0084 41.3313 22.0084 39.0966 23.3867 37.7183C24.765 36.34 26.9997 36.34 28.378 37.7183L35.508 44.8482L52.2636 28.0926C53.6419 26.7142 55.8766 26.7142 57.255 28.0926Z",
    fill: "#5CD17E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.2d41595165b90a34a0b05f0362edb191.svg";
export { ForwardRef as ReactComponent };